<div *ngIf='ready' class='EditVsmComments p-5'>
  <div class='Breadcrumbs'>
    <div class='Breadcrumbs-items'>
      <a [routerLink]="['/contents', 'quick_responses']"
      >
        <mat-icon class='Breadcrumbs-icon back'
        >keyboard_backspace
        </mat-icon
        >
      </a
      >
      <a
        [routerLink]="['/contents', 'vsm_comments']"
        class='Breadcrumbs-item first'
      >Edge Comments</a
      >
      <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
      <span class='Breadcrumbs-item'>{{
          state === 'edit' ? 'Edit' : 'Create'
        }}</span>
    </div>
  </div>
  <div class='EditVsmComments-body mt-5 p-5'>
    <div class='EditVsmComments-form mt-3 p-5'>
      <form [formGroup]='formGroup'>
        <div class='row'>
          <div
            class='EditVsmComments-form-label col col-1 d-flex align-items-center'>
            <mat-label>Name</mat-label>
          </div>
          <div class='col col-11'>
            <app-text-field
              [fieldBackgroundClass]="'white'"
              formControlName='name'
              placeholder='Name'></app-text-field>
          </div>
        </div>
        <div *ngIf='error && error.name' class='row'>
          <div class='col col-12 col-md-9 offset-0 offset-md-3'>
            <div class='alert alert-danger'>
              <p class='mb-0'>{{ error.name }}</p>
            </div>
          </div>
        </div>
        <div class='row mt-3'>
          <div class='col'>
            <app-editor formControlName='response'></app-editor>
          </div>
        </div>
        <div *ngIf='error && error.response' class='row'>
          <div class='col col-12 col-md-9 offset-0 offset-md-3'>
            <div class='alert alert-danger'>
              <p class='mb-0'>{{ error.response }}</p>
            </div>
          </div>
        </div>
        <div class='EditVsmComments-buttons row'>
          <div class='col'>
            <app-button
              [Click]='cancelButtonProperties.onClick'
              [color]='cancelButtonProperties.color'
              [size]='cancelButtonProperties.size'
              [text]='cancelButtonProperties.text'
              class='EditVsmComments-buttons-button'></app-button>
            <app-button
              [Click]='saveButtonProperties.onClick'
              [color]='saveButtonProperties.color'
              [size]='saveButtonProperties.size'
              [text]='getSaveButtonText()'
              class='EditVsmComments-buttons-button'></app-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
